import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import FirebaseHandler from "./index";
import { datoCmsId } from "../dato-cms";
import { doc, getDoc } from "firebase/firestore";
export var STORAGE_URL = "gs://makroskop-b14f3.appspot.com";
export var getUserDocumentRef = function getUserDocumentRef(userId) {
    return doc(FirebaseHandler.firestore, "users", userId);
};
export var loadUserDocument = function loadUserDocument(userId) {
    return getDoc(getUserDocumentRef(userId));
};
export var loadUserData = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(userId) {
        var data, _doc;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return loadUserDocument(userId);
                    case 3:
                        _doc = _context.sent;
                        data = _doc.data();
                        _context.next = 10;
                        break;
                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context["catch"](0);
                        console.error("Error in loadUserData", _context.t0);
                    case 10:
                        return _context.abrupt("return", {
                            bookmarks: data && data.bookmarks ? data.bookmarks : [],
                            readArticles: data && data.readArticles ? data.readArticles : [],
                            newsletterSubscribed: data && data.newsletterSubscribed ? data.newsletterSubscribed : false,
                            customerId: data && data.customer_id ? data.customer_id : undefined
                        });
                    case 11:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, null, [[0, 7]]);
    }));
    return function loadUserData(_x) {
        return _ref.apply(this, arguments);
    };
}();
export var loadArticleDocument = function loadArticleDocument(articleId) {
    return getDoc(doc(FirebaseHandler.firestore, "articles", articleId));
};
export var loadArticleData = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(articleId) {
        var data, _doc2;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return loadArticleDocument(datoCmsId(articleId));
                    case 3:
                        _doc2 = _context2.sent;
                        data = _doc2.data();
                        _context2.next = 10;
                        break;
                    case 7:
                        _context2.prev = 7;
                        _context2.t0 = _context2["catch"](0);
                        console.error("Error in loadArticleData", _context2.t0);
                    case 10:
                        return _context2.abrupt("return", {
                            pixel: data && data.pixel ? data.pixel : undefined,
                            sample: data && data.textSample ? data.textSample : undefined
                        });
                    case 11:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2, null, [[0, 7]]);
    }));
    return function loadArticleData(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
export var loadUserClaims = /*#__PURE__*/ function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3() {
        var _idTokenResult, _idTokenResult$claims, _idTokenResult2, _idTokenResult2$claim, _idTokenResult3, _idTokenResult3$claim, _idTokenResult4, _idTokenResult4$claim;
        var idTokenResult;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return FirebaseHandler.auth.currentUser.getIdTokenResult();
                    case 3:
                        idTokenResult = _context3.sent;
                        _context3.next = 9;
                        break;
                    case 6:
                        _context3.prev = 6;
                        _context3.t0 = _context3["catch"](0);
                        console.error("Error in loadUserClaims", _context3.t0);
                    case 9:
                        return _context3.abrupt("return", {
                            customerId: (_idTokenResult = idTokenResult) === null || _idTokenResult === void 0 ? void 0 : (_idTokenResult$claims = _idTokenResult.claims) === null || _idTokenResult$claims === void 0 ? void 0 : _idTokenResult$claims.customer_id,
                            subscriptionType: (_idTokenResult2 = idTokenResult) === null || _idTokenResult2 === void 0 ? void 0 : (_idTokenResult2$claim = _idTokenResult2.claims) === null || _idTokenResult2$claim === void 0 ? void 0 : _idTokenResult2$claim.subscriptionType,
                            subscriptionStatus: (_idTokenResult3 = idTokenResult) === null || _idTokenResult3 === void 0 ? void 0 : (_idTokenResult3$claim = _idTokenResult3.claims) === null || _idTokenResult3$claim === void 0 ? void 0 : _idTokenResult3$claim.subscriptionStatus,
                            subscriptionEnd: (_idTokenResult4 = idTokenResult) !== null && _idTokenResult4 !== void 0 && (_idTokenResult4$claim = _idTokenResult4.claims) !== null && _idTokenResult4$claim !== void 0 && _idTokenResult4$claim.subscriptionEnd ? new Date(idTokenResult.claims.subscriptionEnd * 1000) : undefined
                        });
                    case 10:
                    case "end":
                        return _context3.stop();
                }
            }
        }, _callee3, null, [[0, 6]]);
    }));
    return function loadUserClaims() {
        return _ref3.apply(this, arguments);
    };
}();
